import { defineSlotRecipe } from '@chakra-ui/react';

export const searchEngineMobileSlotRecipe = defineSlotRecipe({
    slots: ['container', 'icon'],
    base: {
        container: {
            justifyContent: 'space-between',
            alignItems: 'center',
            bg: 'white',
            boxShadow: 'search-bar-shadow',
            borderTopRadius: 'md',
            p: 4,
            w: 'full',
        },
        icon: {
            color: 'secondary.500',
        },
    },
});
